import Connector from './connector';

export const InitialSearch = () => <Connector />;
